import { useQuery } from "react-query";
import { getOfficeKeysByRecordNumber } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useGetOfficeKeysByRecordNumber = (recordNumber) => {
  return useQuery(
    ["GetOfficeKeysByRecordNumber", recordNumber],
    () => getOfficeKeysByRecordNumber(recordNumber),
    {
      refetchOnWindowFocus: false,
    }
  );
};
